"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductsGridView = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const app_1 = require("@obvio/app");
const ui_1 = require("@obvio/ui");
const productTile_1 = require("../../productTile");
const StyledGrid = (0, app_1.styled)(ui_1.Grid) `
  gap: ${(theme) => theme.spacing.small};

  grid-template-columns: minmax(0, 1fr);

  @media ${app_1.desktop} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  @media ${app_1.bigScreen} {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`;
function ProductsGridViewLoader() {
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: Array.from({ length: 12 }).map((_v, index) => ((0, jsx_runtime_1.jsx)(productTile_1.ProductTileView, { product: null, loading: true }, index))) }));
}
function ProductsGridView({ products, loading, className, }) {
    return ((0, jsx_runtime_1.jsx)(StyledGrid, Object.assign({ className: className, templateColumns: "repeat(3, minmax(0, 1fr))" }, { children: (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [products === null || products === void 0 ? void 0 : products.map((product) => ((0, jsx_runtime_1.jsx)(productTile_1.ProductTileView, { product: product }, product.id))), loading && (0, jsx_runtime_1.jsx)(ProductsGridViewLoader, {})] }) })));
}
exports.ProductsGridView = ProductsGridView;
